import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Termsandconditions from "../components/Termsandconditions";

function Terms() {

const [isTermsActive, setIsTermsActive] = useState(false); // For Terms and Conditions popup

  // Toggle Terms and Conditions popup
  const handleTermsClick = () => setIsTermsActive(true);
  const handleCloseTerms = () => setIsTermsActive(false);

  return (

    <div className="terms_condition">
      <div className="terms_1">
        <p className="termspopup" onClick={handleTermsClick}>Terms And Conditions</p>
      <Termsandconditions isActive={isTermsActive} onClose={handleCloseTerms} />
      </div>
      <div className="terms_1">
        <p>Having Problems Logging in?</p>
        <p>Please call <a href="tel:+6597683938">(+65) 97683938</a>,{" "}<a href="tel:+6565140480">65140480</a>
  </p>
      </div>
    </div>

    );
}

export default Terms;
